import { CACHE_TAG } from 'enums';

import apiRoutes from 'router/routes/ApiRoutes';

import { apiContainer } from 'store';

import { selectDataFromResponse } from 'utils/objects';

export const successorBorrowerConfigurationApi = apiContainer.injectEndpoints({
  endpoints: builder => ({
    getSuccessorBorrowerConfiguration: builder.query({
      query: params => ({
        url: apiRoutes.successorBorrowersConfigurationPath(),
        method: 'GET',
        params,
      }),
      transformResponse: selectDataFromResponse,
      providesTags: [CACHE_TAG.successorBorrowerConfiguration],
    }),
  }),
});

export const { useGetSuccessorBorrowerConfigurationQuery } = successorBorrowerConfigurationApi;
